import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppRouter } from './app/router';
import { AppProviders } from './app/providers';

// Ordem de importação de CSS (mesmo padrão do tt-site — ver
// apps/web/app/[locale]/layout.tsx + globals.css do repo tt-site, TTP-201):
//   1. shared-ui-react/style.css → agrega tokens.css + theme.css do
//      @tervior-tech/tervior-design-system (Brutalist). NÃO importar
//      tokens.css/theme.css direto — já vêm inclusos aqui.
//   2. IBM Plex Sans/Mono via @fontsource, pesos 400/500 só (regra Brutalist:
//      nunca 300 nem 700) — equivalente ao next/font/google do tt-site, sem
//      dependência de rede em dev/build num Vite SPA.
//   3. ./index.css → @import 'tailwindcss' + @theme do dashboard (precisa
//      ser o último: é o arquivo que o plugin @tailwindcss/vite trata como
//      entry point — @theme fora dele não é aplicado).
import '@tervior-tech/tervior-shared-ui-react/style.css';
// Subset `latin` (não o default `400.css`/`500.css`, que empacota grego,
// cirílico, vietnamita etc.): cobre os acentos do pt-BR (ã, õ, ç...) e é o
// único idioma do dashboard no v1 (CLAUDE.md — "Copy do dashboard: pt-BR
// único"). Evita ~20 arquivos de fonte não utilizados no build.
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-500.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-500.css';
import './index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root not found in index.html');
}

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
);
